import { useState } from 'react';
import { Navigate } from 'react-router-dom';

function LoginPage({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [goToDashboard, setGoToDashboard] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');

    try {
      const response = await fetch('/api/admin/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
          email,
          password
        })
      });

      const payload = await response.json();
      if (!response.ok) {
        throw new Error(payload.error || 'Ошибка входа');
      }

      onLoginSuccess(payload.user || null);
      setGoToDashboard(true);
    } catch (submitError) {
      setError(submitError.message || 'Ошибка входа');
    } finally {
      setSubmitting(false);
    }
  };

  if (goToDashboard) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="auth-shell">
      <section className="auth-card">
        <p className="header-kicker">Администрирование TopTopAff</p>
        <h2>Вход в админ-панель</h2>
        <p className="auth-note">Используйте данные администратора для доступа к дашборду и БД.</p>

        <form className="auth-form" onSubmit={handleSubmit}>
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="admin@company.com"
              required
            />
          </label>

          <label>
            Пароль
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="********"
              required
            />
          </label>

          {error ? <p className="offer-error">{error}</p> : null}

          <button className="accent-button" type="submit" disabled={submitting}>
            {submitting ? 'Вход...' : 'Войти'}
          </button>
        </form>
      </section>
    </div>
  );
}

export default LoginPage;
